// Route paths constants
export const ROUTES = {
  // Public routes
  SIGN_IN: '/sign-in',
  
  // Protected routes
  PROFILE: '/profile',
  JOB_MANAGEMENT: '/jobs-management',
  BLOG_MANAGEMENT: '/blogs-management',
  CULTURE_MANAGEMENT: '/cultures-management',
  USER_MANAGEMENT: '/users-management',
  CONTACT_MANAGEMENT: '/contacts-management',
  JOB_SUBMISSIONS_MANAGEMENT: '/job-submissions-management',
} as const;